var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCrossCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_x5F_cross_x5F_circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1.031c6.043,0,10.932,4.887,10.932,10.932c0,6.043-4.889,10.932-10.932,10.932c-6.045,0-10.932-4.889-10.932-10.932 C1.068,5.918,5.955,1.031,12,1.031 M15.923,6.497L12,10.422L8.075,6.497L6.534,8.038l3.924,3.925l-3.924,3.923l1.541,1.542 L12,13.506l3.923,3.924l1.543-1.543l-3.924-3.923l3.924-3.925L15.923,6.497z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCrossCircle);
export default __webpack_public_path__ + "static/media/ic_cross_circle.da95b10c5970b43bb24b054ba64abe5d.svg";
export { ForwardRef as ReactComponent };